import { InlineStack, Card, BlockStack, SkeletonBodyText, SkeletonDisplayText, Divider } from '@shopify/polaris';
import React from 'react';
import '../css/skeleton.css';

const PlanSkeleton = () => {
    let n = 5;
    return <>
        <InlineStack gap="400" align='center' blockAlign='center' wrap={false}>
            {
                [...Array(n)].map((_: any, ind: number) => {
                    return (
                        <div className="custom-pricing-skeleton-card " key={ind}>
                            <Card key={ind}>
                                <div className='Custom-Alpha-Card__Section'>
                                    <BlockStack gap="500">
                                        <InlineStack gap="200" align='center'>
                                            <div className='Custom__Text--Skeleton'>
                                                <SkeletonBodyText lines={1} />
                                            </div>
                                            <div className='Custom__Badge--Skeleton'>
                                                <SkeletonDisplayText size="small" />
                                            </div>
                                        </InlineStack>
                                        <BlockStack gap="200" inlineAlign="center">
                                            <InlineStack gap="200" blockAlign='baseline'>
                                                <div className='Custom__Pricing--Skeleton'>
                                                    <SkeletonDisplayText size="extraLarge" />
                                                </div>
                                                <div className='Custom__TextMonth--Skeleton'>
                                                    <SkeletonBodyText lines={1} />
                                                </div>
                                            </InlineStack>
                                            <div className='Custom__Order--Skeleton'>
                                                <SkeletonBodyText lines={1} />
                                            </div>
                                        </BlockStack>
                                        <Divider />
                                        <BlockStack gap="400">
                                            <div className='Custom__Order--Skeleton'>
                                                <SkeletonBodyText lines={1} />
                                            </div>
                                            <div className='Custom__Descreption--Skeleton'>
                                                <SkeletonBodyText lines={4} />
                                            </div>
                                        </BlockStack>
                                        <div className='Custom__PricingButton--Skeleton'>
                                            <SkeletonDisplayText size="extraLarge" />
                                        </div>
                                    </BlockStack>
                                </div>
                            </Card>
                        </div>
                    );
                })
            }
        </InlineStack>
    </>;
}

export default PlanSkeleton;